const url = new URL(document.location.href);
const { searchParams } = url;
const debugParam = searchParams.get("ads-debug");
const allowLog = debugParam != null;
const consolePrefix = "[Ads]";

let bgConsoleColor = 'white';
let fontConsoleColor = 'black';
let consoleStyle = `background: ${bgConsoleColor}; color:${fontConsoleColor};padding: 2px 5px;`;

class DebugLog {
  constructor() {
  }
  error() {
    if (allowLog) {
      let props = [ ...arguments ];
      props[0] = `${consolePrefix} ${props[0]}`;
      console.error.apply(console, props);
    }
  }
  log() {
    if (allowLog) {
      let props = [ ...arguments ];
      props[0] = `${consolePrefix} ${props[0]}`;
      console.log.apply(console, props);
    }
  }
  warn() {
    if (allowLog) {
      let props = [ ...arguments ];
      props[0] = `${consolePrefix} ${props[0]}`;
      console.warn.apply(console, props);
    }
  }
}

const debug = new DebugLog();
export { debug }
